// extracted by mini-css-extract-plugin
module.exports = {"layout":"NavigationLayout_layout__1qXTe","main":"NavigationLayout_main__uVpxT","content":"NavigationLayout_content__cqGBb"};